import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfigListComponent } from './components/config-list/config-list.component';
import { ConfigComponent } from './components/config/config.component';
import { LimitSettingsComponent } from './components/limit-settings/limit-settings.component';
import { LoginComponent } from './components/login/login.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { SampleListComponent } from './components/sample-list/sample-list.component';
import { TestManagementComponent } from './components/test-management/test-management.component';
import { UserConfigurationComponent } from './components/user-configuration/user-configuration.component';
import { ErrorComponent } from './error.component';
import { ENavigationRoute } from './model/enum/navigation-route';
import { LoginGuard } from './tools/login-guard';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: ENavigationRoute.Login },
    { path: ENavigationRoute.Config, component: ConfigComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.ConfigList, component: ConfigListComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.LimitSettings, component: LimitSettingsComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.SampleList, component: SampleListComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.TestManagement, component: TestManagementComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.User, component: UserConfigurationComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Error, component: ErrorComponent },
    { path: ENavigationRoute.Login, component: LoginComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: '**', component: ErrorComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
